import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const atbCarouselsPDPSelector = createSelector(testTargetOffersSelector, offers => offers.atbCarouselsPDP || Empty.Object);

export { atbCarouselsPDPSelector };
